<script lang="ts">
  import { page } from '$app/stores'
  import ErrorPage from '$lib/components/ErrorPage.svelte'

  let error = $derived($page.error)
</script>

<ErrorPage
  status={error?.status || $page.status || 500}
  title={error?.title || 'Error'}
  message={error?.message || 'An unexpected error occurred. Please try again later.'}
/>
